import { Box, Button, Stack } from "@mui/material"
import { format } from "date-fns"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AuditTopBarDownloadButton } from "slot-definitions"
import { htmlToText } from "lib/html-to-text"
import { useMobile } from "lib/@components/mobile"
import { If } from "lib/@components/switch"
import { createEvent } from "library/local-events"
import { singleWorksheetDownload } from "lib/excel-download"

export const AuditDownloadExtra = createEvent("AuditDownloadExtra")

export function AuditTopBar({ setOpen, type, fileNamePrefix, filterFn }) {
    const { data, ok, hideButtons, fetchAll } = useBoundContext()
    const isMobile = useMobile()
    const handleCloseClick = () => {
        if (!isMobile) {
            setOpen(false)
        } else {
            setOpen(false)
            ok()
        }
    }

    return (
        <If truthy={!hideButtons}>
            <Stack
                sx={{
                    flexDirection: isMobile ? "row-reverse" : "row",
                }}
                mb={isMobile ? 0 : 3}
            >
                <Box>
                    <Button
                        onClick={handleCloseClick}
                        startIcon={<Iconify icon="ic:round-cancel" />}
                        variant={isMobile ? "contained" : "text"}
                        id="closeAuditBtn"
                        data-cy="activity-log-exit"
                    >
                        Exit
                    </Button>
                </Box>
                <Box flex={1} />
                <AuditTopBarDownloadButton.Slot type={type}>
                    <Box>
                        <Button
                            onClick={handleDownloadClick}
                            startIcon={<Iconify icon="ic:round-download" />}
                            variant="contained"
                            id="downloadAuditBtn"
                            data-cy="activity-log-download-btn"
                        >
                            Download
                        </Button>
                    </Box>
                </AuditTopBarDownloadButton.Slot>
            </Stack>
        </If>
    )

    async function handleDownloadClick() {
        // When the log is paginated only a window is loaded; fetch the complete set for export.
        const exportData = fetchAll ? await fetchAll() : data
        const groupedData = Object.values(exportData.groupBy("referenceId"))
        const filteredData = groupedData.filter(filterFn).flatMap((entry) => entry)

        const formattedData = filteredData.map((d) => {
            const row = {
                Version: d.referenceId.split("-version:")[1]?.split(".")[0],
                Name: d.userName,
                Date: format(new Date(d.date), "dd/MM/yyyy"),
                Time: format(new Date(d.date), "p"),
                Comment: d.shortDescription,
                Reason: d?.payload?.reason && htmlToText(d.payload.reason, true),
            }
            AuditDownloadExtra(type).raise({ row, data: d })
            return row
        })

        let row = 1
        const merge = []
        Object.values(filteredData.groupBy("referenceId")).forEach((group) => {
            const endRow = row + (group.length - 1)
            merge.push({ s: { r: row, c: 0 }, e: { r: endRow, c: 0 } })
            row = endRow + 1
        })

        singleWorksheetDownload({
            fileName: `${fileNamePrefix}-ActivityLog.xlsx`,
            sheetName: "Activity-Log",
            data: formattedData,
            mergedCells: merge,
        })
    }
}
